module.exports = __webpack_public_path__ + "static/img/role0014.c5d462e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0014.jpg
// module id = BaAB
// module chunks = 1